import { Component, Input } from '@angular/core';

@Component({
    selector: 'm4u-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    @Input() Class: string = '';
}
